import { DatePicker } from './date-picker';

export default DatePicker;
